import { createSelector } from 'reselect'

export const getIsArchived = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].isArchived
}

export const getListId = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].listId
}

export const getLists = (state, props) => {
  return state['view-board'].view[state['view-board'].cards[props.cardContext.id].boardId].lists
}

export const getListsById = (state, props) => {
  return state['view-board'].lists
}

export default () => createSelector(
  [
    getIsArchived,
    getListId,
    getLists,
    getListsById,
  ],
  (
    isArchived,
    listId,
    lists,
    listsById,
  ) => ({
    isArchived,
    listId,
    lists,
    listsById,
  })
)
